import { render } from "./MultimediaImages.vue?vue&type=template&id=f192f584"
import script from "./MultimediaImages.vue?vue&type=script&lang=js"
export * from "./MultimediaImages.vue?vue&type=script&lang=js"

import "./MultimediaImages.vue?vue&type=style&index=0&id=f192f584&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__